import { useMemo } from 'react';
import { Line, Header } from '../types';

export const useSubmitButtonState = (lines: Line[], selectedHeader?: Header, hasSubmitted?: boolean) => {
  const isSubmitDisabled = useMemo(() => {
    // Disable if no header is selected
    if (!selectedHeader) {
      return true;
    }
    
    // Disable if already submitted for current header
    if (hasSubmitted) {
      return true;
    }
    
    // Disable if all lines have 'success' status
    return lines.length > 0 && lines.every(line => 
      line.status && line.status.toLowerCase() === 'success'
    );
  }, [lines, selectedHeader, hasSubmitted]);

  return { isSubmitDisabled };
};